<template>
  <div>
    <!--Route Related Geographies-->
    <template v-for="route in routes">
      <gmap-polyline
        :key="`r-${route.id}`"
        :path="getPath(route)"
        :options="getPathOptions(route)"
        @click="onRouteClick(route)"
      ></gmap-polyline>

      <gmap-marker
        v-for="stop in route.Stops"
        :key="`stop-${stop.id}`"
        :position="stop.point"
        :icon="getIcon('Stop', stop)"
        @click="onRouteClick(route)"
      ></gmap-marker>
    </template>

    <div class="box has-text-centered is-add-stop" v-if="!route || (route && !route.isOptimized)">
      <p>
        <strong>Route: </strong>
        <span v-if="route">
          {{ route.name }}
          <button type="button" class="delete" @click="route = null"></button>
        </span>
        <span v-else>Select a Route</span>
      </p>

      <div class="buttons is-right" v-if="route">
        <button type="button" class="button is-success" @click="onOptimizeRoute">Optimize Route</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as MapperHelpers from '../MapperHelpers'

import RouteDetail from '../Components/RouteDetail.vue'

export default {
  name: 'MapperOptimizeRoute',

  props: [
    'status',
    'routes',
    'locations',
    'hubs'
  ],

  data () {
    return {
      route: null
    }
  },

  methods: {
    getIcon: MapperHelpers.getIcon,
    getPath: MapperHelpers.getPath,
    getPathOptions: MapperHelpers.getPathOptions,

    onCancel () {
      this.$emit('update:status', 'Overview')
    },

    onRouteClick (route) {
      if (route.Stops.length > 23) {
        this.$handleError('This route has more than 23 stops.')
        return
      }

      if (!route.departureSiteId || !route.returnSiteId) {
        this.$handleError('This route does not have either a depatureSite or a returnSite')
        return
      }

      this.route = route
    },

    async onOptimizeRoute () {
      if (this.route) {
        const loader = this.$loading.open()
        try {

          const route = await new Promise((resolve, reject) => {
            const request = {
              origin: MapperHelpers.toGooglePoint(this.route.departureSite.point),
              travelMode: 'DRIVING',
              waypoints: this.route.Stops.map(location => ({
                location: MapperHelpers.toGooglePoint(location.point),
                stopover: true
              })),
              optimizeWaypoints: true,
              destination: MapperHelpers.toGooglePoint(this.route.returnSite.point)
            }

            const service = new google.maps.DirectionsService()

            service.route(request, (result, status) => {
              if (status === 'OK') {
                resolve(result)
              } else {
                reject(new Error(status))
              }
            })
          })

          const locationsInOrder = MapperHelpers.reorderStops(route.routes[0], this.route.Stops)

          for (let i = 0; i < locationsInOrder.length; i++) {
            const stop = locationsInOrder[i]
            await this.$entity.update('Stop', stop.id, {
              stopNumber: i + 1
            })
          }

          this.$entity.update('Route', this.route.id, {
            plannedRoutePath: {
              points: MapperHelpers.decodePolyline(route.routes[0].overview_polyline)
            }
          })

          this.$set(this.route, 'isOptimized', true)
          this.$set(this.route, 'route', route.routes[0])
          this.$set(this.route, 'plannedRoutePath', {
            points: MapperHelpers.decodePolyline(route.routes[0].overview_polyline)
          })
          this.$forceUpdate()

          this.$emit('update:status', 'Overview')
        } catch (e) {
          console.error(e)
          this.$handleError('There was an error optimizing this route', e.response.data)
        } finally {
          loader.close()
        }
      }
    }
  },

  components: {
    RouteDetail
  }
}
</script>

<style lang="scss" scoped>
  .message {
    position: absolute;
    left: unset !important;
    bottom: unset !important;
    top: 4rem;
    right: 1rem;
    max-width: 25vw;
  }

  .route-list {
    position: absolute;
    top: 4rem;
    right: 1rem;
    bottom: 1rem;
    display: flex;
    flex-direction: column;

    width: 350px;

    .header {
      flex: 0 0 auto;
    }

    .list {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: visible;
      margin-left: -1rem;
      margin-right: -1rem;
      padding: .5rem;

      .detail {
        border-bottom: #cccccc 1px solid;
      }
    }

    .controls {
      flex: 0 0 auto;
    }
  }

  .box.is-add-stop {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translateX(-50%);
    width: 25vw;
  }
</style>
